import React from 'react'
import { string, node, arrayOf } from 'prop-types'
import classNames from 'src/common/helpers/class-names'


const blk = 'co-product-list'

const Main = ({
  className, children, mix, mods,
}) => {
  const baseClass = classNames({
    blk, elt: 'main-cntr', mix, mods,
  })
  const containerClass = `${className} ${baseClass}`
  return (
    <ul className={containerClass}>
      {children}
    </ul>
  )
}

Main.propTypes = {
  className: string,
  children: node,
  mix: string,
  mods: arrayOf(string),
}

Main.defaultProps = {
  className: '',
  children: null,
  mix: '',
  mods: [],
}

export default Main



// WEBPACK FOOTER //
// ./shared/interim/product-list/main.js